export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8802.2f3fbbf2.jpg";